import _ from 'lodash';
import React from 'react';
import {Button, SvgIcon} from '@material-ui/core';
import {ProductsIcon, StoreIcon} from '@treez-ui/core/icons';
import {ProductListView} from '~/lib/product';

const {CARD, MERGE, STORE_MATRIX, TABLE, TILE} = ProductListView;

interface Props {
    currentView: ProductListView;
    viewOptions: ProductListView[];
    setProductView: Function;
}

export const ProductViewOptions = (props: Props) => {
    const {currentView, viewOptions, setProductView} = props;

    const renderView = (view: ProductListView) => {
        setProductView(view);
    };

    return (
        <div>
            {viewOptions.length > 1 && (
                <div className="product-view-options-container">
                    {_.includes(viewOptions, STORE_MATRIX) && (
                        <Button
                            className={currentView === STORE_MATRIX ? 'active' : ''}
                            onClick={() => renderView(STORE_MATRIX)}
                        >
                            <StoreIcon />
                        </Button>
                    )}
                    {_.includes(viewOptions, TABLE) && (
                        <Button
                            className={currentView === TABLE ? 'active' : ''}
                            onClick={() => renderView(TABLE)}
                        >
                            <SvgIcon>
                                <path
                                    d="M5,8.75 C4.58578644,8.75 4.25,8.41421356 4.25,8 C4.25,7.58578644 4.58578644,7.25 5,7.25 L19,7.25 C19.4142136,7.25 19.75,7.58578644 19.75,8 C19.75,8.41421356 19.4142136,8.75 19,8.75 L5,8.75 Z M5,16.75 C4.58578644,16.75 4.25,16.4142136 4.25,16 C4.25,15.5857864 4.58578644,15.25 5,15.25 L19,15.25 C19.4142136,15.25 19.75,15.5857864 19.75,16 C19.75,16.4142136 19.4142136,16.75 19,16.75 L5,16.75 Z M7,12.75 C6.58578644,12.75 6.25,12.4142136 6.25,12 C6.25,11.5857864 6.58578644,11.25 7,11.25 L17,11.25 C17.4142136,11.25 17.75,11.5857864 17.75,12 C17.75,12.4142136 17.4142136,12.75 17,12.75 L7,12.75 Z"
                                    id="path-1"
                                />
                            </SvgIcon>
                        </Button>
                    )}
                    {_.includes(viewOptions, CARD) && (
                        <Button
                            className={currentView === CARD ? 'active' : ''}
                            onClick={() => renderView(CARD)}
                        >
                            <SvgIcon>
                                <path
                                    d="M23,4 C23.5522847,4 24,4.44771525 24,5 L24,19 C24,19.5522847 23.5522847,20 23,20 L1,20 C0.44771525,20 0,19.5522847 0,19 L0,5 C0,4.44771525 0.44771525,4 1,4 L23,4 Z M22.5,5.5 L1.5,5.5 L1.5,18.5 L22.5,18.5 L22.5,5.5 Z M10,8 C10.5522847,8 11,8.44771525 11,9 L11,15 C11,15.5522847 10.5522847,16 10,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L4,9 C4,8.44771525 4.44771525,8 5,8 L10,8 Z M9.5,9.5 L5.5,9.5 L5.5,14.5 L9.5,14.5 L9.5,9.5 Z M13.5,8.25 L19.5,8.25 C19.9142136,8.25 20.25,8.58578644 20.25,9 C20.25,9.41421356 19.9142136,9.75 19.5,9.75 L13.5,9.75 C13.0857864,9.75 12.75,9.41421356 12.75,9 C12.75,8.58578644 13.0857864,8.25 13.5,8.25 Z M13.5,11.25 L19.5,11.25 C19.9142136,11.25 20.25,11.5857864 20.25,12 C20.25,12.4142136 19.9142136,12.75 19.5,12.75 L13.5,12.75 C13.0857864,12.75 12.75,12.4142136 12.75,12 C12.75,11.5857864 13.0857864,11.25 13.5,11.25 Z M13.5,14.25 L19.5,14.25 C19.9142136,14.25 20.25,14.5857864 20.25,15 C20.25,15.4142136 19.9142136,15.75 19.5,15.75 L13.5,15.75 C13.0857864,15.75 12.75,15.4142136 12.75,15 C12.75,14.5857864 13.0857864,14.25 13.5,14.25 Z"
                                    id="path-1"
                                />
                            </SvgIcon>
                        </Button>
                    )}
                    {_.includes(viewOptions, TILE) && (
                        <Button
                            className={currentView === TILE ? 'active' : ''}
                            onClick={() => renderView(TILE)}
                        >
                            <ProductsIcon />
                        </Button>
                    )}
                    {_.includes(viewOptions, MERGE) && (
                        <Button
                            className={currentView === MERGE ? 'active' : ''}
                            onClick={() => renderView(MERGE)}
                        >
                            <ProductsIcon />
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProductViewOptions;
